import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { dailyForecastState } from '@store';

import { DailyForecastData } from '../store/types';

const getFilteredData = (data?: DailyForecastData) => {
  if (!data?.daypart?.length) {
    return [];
  }
  const { daypartName, iconCodeExtend, precipChance, snowRange, precipType, temperature } = data.daypart[0];

  return Array.from({ length: 1 }, (_, index) => {
    const modifiedIndex = index + 2;

    const snowForecasted = snowRange[modifiedIndex] ? true : false;

    return {
      snowForecasted,
      daypartName: daypartName[modifiedIndex],
      iconCodeExtend: iconCodeExtend[modifiedIndex],
      temperatureHigh: temperature[modifiedIndex],
      temperatureLow: temperature[modifiedIndex + 1],
      precipChance: precipChance[modifiedIndex],
      precipType: precipType[modifiedIndex],
      snowRange: snowRange[modifiedIndex],
    };
  });
};

export const useTomorrowForecast = () => {
  const { data } = useRecoilValue(dailyForecastState);

  return useMemo(() => getFilteredData(data), [data]);
};
